import React, { useState, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Col, Label, Row } from 'reactstrap';
import { SearchableSelectHookForm, TextAreaHookForm, TextFieldHookForm } from '../../../../../../../layout/HookFormInputs';
import { apiErrors, checkWhiteSpaces, alphabetsOnlyForName, alphaNumeric, number, notify, userDetails, alphabetsOnly, triggerFileDownloadByUrl } from "../../../../../../../../helper";
import HeaderTitle from '../../../../../../../common/HeaderTitle';
import axiosHelper from '../../../../../../../../axiosHelper';
import { API, APIUSEROLD } from '../../../../../../../../config/constants';
import { getCurrencyList } from '../../../../../../supplierListAll/Actions';
import { cloneDeep } from 'lodash';
import PopupMsgWrapper from '../../../../../../../common/PopupMsgWrapper';
import { getReasonAuditListing } from '../../../../../../NsaAudit/Action';
import DatePicker from "react-datepicker";
import LoaderCustom from '../../../../../../../common/LoaderCustom';
import FileUpload from '../../../KysOne/FileUpload';
import { useHistory } from 'react-router-dom';
import { getSourceOfOrigin } from '../../../../../../VendorNeedForm/Actions';
import KysTwoView from './KysTwoView';

let radioValidateMsg = "This field is required.";

let userData = userDetails();

const fileConfig = {
    allFilesType: {
        allowedFileTypes: [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/msword", // Allow .doc files
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
        ],
        maxSize: 5, // In MB
        validationMessage: "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
    }
}
const todayDate = new Date();

const KysTwoForm = (props) => {
    const { viewDataFromSupplier } = props;


    const history = useHistory()
    const formController = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
    });


    const {
        register,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
        reset,
        trigger,
        watch
    } = formController;

    const ieFormController = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const {
        register: ieRegister,
        formState: { errors: ieErrors },
        handleSubmit: ieHandleSubmit,
        control: ieControl,
        reset: ieReset,
        watch: ieWatch
    } = ieFormController;

    // 

    const [categoryList, setCategoryList] = useState([]);
    const [paymentTerms, setPaymentTerms] = useState([]);
    const [currencyMasterList, setCurrencyMasterList] = useState([]);
    const [groupingKeyList, setGroupingKeyList] = useState([]);
    const [paymentMethodList, setPaymentMethodList] = useState([]);
    const [purchasingOrganizationList, setPurchasingOrganizationList] = useState([]);
    const [accountGroupReconciliationList, setAccountGroupReconciliationList] = useState([]);
    const [companyCodeList, setCompanyCodeList] = useState([]);
    const [supplierClassificationList, setSupplierClassificationList] = useState([]);
    const [sourceOfOriginList, setSourceOfOriginList] = useState([]);
    const [exceptionalFlowReasons, setExceptionalFlowReasons] = useState([]);
    const [isExceptionalFlowModalOpen, setIsExceptionalFlowModalOpen] = useState(false);
    const [vendorRequirementRegistrationId, setVendorRequirementRegistrationId] = useState(0);
    const [showTabLoader, setShowTabLoader] = useState(true);
    const [kys2Detail, setKys2Detail] = useState(null);

    const [kys2FormSubmitData, setKys2FormSubmitData] = useState(null);
    const [isApproveKys2PopupOpen, setIsApproveKys2PopupOpen] = useState(false);
    const [isRejectKys2PopupOpen, setIsRejectKys2PopupOpen] = useState(false);
    const [kys2RejectRemark, setKys2RejectRemark] = useState(false);
    const [updateKys2PopupOpen, setUpdateKys2PopupOpen] = useState(false);
    const [costSheetDocumentAttachment, setCostSheetDocumentAttachment] = useState(null)
    const [codeOfConductDocumentAttachment, setCodeOfConductDocumentAttachment] = useState(null)
    const [productSourcingDocumentAttachment, setProductSourcingDocumentAttachment] = useState(null)
    // const [selectedExceptionalFlowReasons, setSelectedExceptionalFlowReasons] = useState([])

    const getOriginOfSource = () => {
        axiosHelper.get(`${APIUSEROLD.getSourceOfOriginVendor}`).then((response) => {
            if (response?.data?.IsSuccessful) {
                let listItems = response?.data?.Data?.map(el => ({ label: el?.SourceName, value: el?.Id }))
                setSourceOfOriginList(listItems);
            }
        })
            .catch((error) => {
                if (error.response.status === 401) {
                    apiErrors(error)
                } else {

                    throw error; // Re-throw the error to the caller
                }
            });
    };

    const getExceptionalFlowReasons = () => {
        getReasonAuditListing()
            .then((res) => {
                let items = res?.Data?.map((typeofEstablishment) => ({
                    value: typeofEstablishment.ReasonId,
                    label: typeofEstablishment.ReasonName,
                }));
                // remove Audit Score
                let withoutAuditScore = items.filter(el => el?.label !== "Audit Score");
                setExceptionalFlowReasons(withoutAuditScore);
            })
            .catch(() => { });
    };

    // 
    // GetGroupingKeyList

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("VendorRequirementRegistrationId");
        if (id) {
            setVendorRequirementRegistrationId(id);
            getKYS2Detail(id)
        }
        getExceptionalFlowReasons()
    }, []);

    const getKYS2Detail = (id) => {
        axiosHelper.get(`${API.getKYS2Detail}?VendorRequirementRegistrationId=${id}`).then((response) => {
            if (response?.data?.IsSuccessful) {
                hidePageLoader()
                setKys2Detail(response?.data?.Data)
            }
        })
            .catch((error) => {
                if (error.response.status === 401) {
                    apiErrors(error)
                } else {

                    if (!error?.response?.data?.IsSuccessful) {
                        notify.error(error?.response?.data?.ErrorMessage)
                    }
                }
            });
    }
    const getEmptyFileObjectForEditForm = (fileName) => {
        return fileName ? { fileName, base64String: "", fileType: "" } : null;
    }
    const fillKys2FormData = (data) => {
        let CostSheetDocumentAttachment = getEmptyFileObjectForEditForm(data?.CostSheetDocumentName);
        let CodeOfConductDocumentAttachment = getEmptyFileObjectForEditForm(data?.CodeOfConductDocumentName);
        let ProductSourcingDocumentAttachment = getEmptyFileObjectForEditForm(data?.ProductSourcingDocumentName);

        let formData = {
            ...data,
            CostSheetDocumentAttachment,
            CodeOfConductDocumentAttachment,
            ProductSourcingDocumentAttachment,
            Origin_of_Sources: !!data?.Origin_of_Sources ? {
                label: data?.Origin_of_SourcesName,
                value: data?.Origin_of_Sources
            } : null,
            SupplierCategory: !!data?.SupplierCategory ? {
                label: data?.SupplierCategoryName,
                value: data?.SupplierCategory
            } : null,
            PaymentTerms: !!data?.PaymentTerms ? {
                label: data?.PaymentTermsName,
                value: data?.PaymentTerms
            } : null,
            GroupingKey: !!data?.GroupingKey ? {
                label: data?.GroupingKeyName,
                value: data?.GroupingKey
            } : null,
            CompanyCode: !!data?.CompanyCode ? {
                label: data?.CompanyCodeName,
                value: data?.CompanyCode
            } : null,
            PaymentCurrency: !!data?.PaymentCurrency ? {
                label: data?.PaymentCurrencyName,
                value: data?.PaymentCurrency
            } : null,
            PurchasingOrganization: !!data?.PurchasingOrganization ? {
                label: data?.PurchasingOrganizationName,
                value: data?.PurchasingOrganization
            } : null,
            VendorGSTClassification: !!data?.VendorGSTClassification ? {
                label: data?.SupplierClassificationName,
                value: data?.VendorGSTClassification
            } : null,
            AccountGroup: !!data?.AccountGroup ? {
                label: data?.AccountGroupName,
                value: data?.AccountGroup
            } : null,
            PaymentMethod: !!data?.PaymentMethod ? {
                label: data?.PaymentMethodName,
                value: data?.PaymentMethod
            } : null,
            HavellsBusinessContribution: data?.HavellsBusinessContribution,
            ReconciliationAccount: data?.ReconciliationAccount,
            SOCCode: data?.SOCCode,
            IsMetOwnerOrDirector: data?.IsMetOwnerOrDirector?.toString(),
            OwnerOfCompanyRemark: data?.OwnerOfCompanyRemark,
            AddressProof: data?.AddressProof?.toString(),
            AddressProofRemark: data?.AddressProofRemark,
            PANCard: data?.PANCard?.toString(),
            PANCardRemark: data?.PANCardRemark,
            IsMSMESupplier: data?.IsMSMESupplier?.toString(),
            MSMESupplierRemark: data?.MSMESupplierRemark,
            MSMECertificate: data?.MSMECertificate?.toString(),
            MSMECertificateRemark: data?.MSMECertificateRemark,
            CancelledCheque: data?.CancelledCheque?.toString(),
            CancelledChequeRemark: data?.CancelledChequeRemark,
            GSTINCertificate: data?.GSTINCertificate?.toString(),
            GSTINCertificateRemark: data?.GSTINCertificateRemark,
            PF_ESIRegistration: data?.PF_ESIRegistration?.toString(),
            PF_ESIRegistrationRemark: data?.PF_ESIRegistrationRemark,
            CostSheet: data?.CostSheet?.toString(),
            CostSheetRemark: data?.CostSheetRemark,
            CodeOfConduct: data?.CodeOfConduct?.toString(),
            CodeOfConductRemark: data?.CodeOfConductRemark,
            Name: data?.Name,
            DepartmentName: data?.DepartmentName,
            ContactPersonName: data?.ContactPersonName,
            Remark: data?.Remark,
            ProductSourcing: data?.ProductSourcing?.toString(),
        }
        setCostSheetDocumentAttachment(CostSheetDocumentAttachment);
        setCodeOfConductDocumentAttachment(CodeOfConductDocumentAttachment);
        setProductSourcingDocumentAttachment(ProductSourcingDocumentAttachment);
        reset(formData)
    }

    const getCategoryMaster = () => {
        axiosHelper.get(API.GetCategoryMaster).then((response) => {
            if (response.data.IsSuccessful) {
                let list = response?.data?.Data?.map(el => ({ label: el?.Name, value: el?.Id }));
                setCategoryList(list)
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const getPaymentTerms = () => {
        axiosHelper.get(APIUSEROLD.getPaymentTermsVendorNeed).then((response) => {
            if (response.data.IsSuccessful) {
                let listItems = response?.data?.Data.map(el => ({ label: el?.Name, value: el?.Id }))
                setPaymentTerms(listItems);
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const getGroupingKeyList = () => {
        axiosHelper.get(API.getGroupingKeyList).then((response) => {
            if (response.data.IsSuccessful) {
                let listItems = response?.data?.Data?.GroupingKeyList?.map(el => ({ label: el?.Name, value: el?.Id }))
                setGroupingKeyList(listItems);
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const getPaymentMethodList = () => {
        axiosHelper.get(API.getPaymentMethodList).then((response) => {
            if (response.data.IsSuccessful) {
                let listItems = response?.data?.Data?.PaymentMethodList?.map(el => ({ label: el?.Name, value: el?.Id }))
                setPaymentMethodList(listItems);
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const getPurchasingOrganizationList = () => {
        axiosHelper.get(API.getPurchasingOrganizationList).then((response) => {
            if (response.data.IsSuccessful) {
                let listItems = response?.data?.Data?.PurchasingOrganizationList?.map(el => ({ label: el?.Name, value: el?.Id }))
                setPurchasingOrganizationList(listItems);
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const getAccountGroupReconciliationList = () => {
        axiosHelper.get(API.getAccountGroupReconciliationList).then((response) => {
            if (response.data.IsSuccessful) {
                let listItems = response?.data?.Data?.map(el => ({ label: el?.AccountGroupName, value: el?.AccountGroupId }))
                setAccountGroupReconciliationList(listItems);
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const getCompanyCodeList = () => {
        axiosHelper.get(API.getCompanyCodeList).then((response) => {
            if (response.data.IsSuccessful) {
                let listItems = response?.data?.Data?.CompanyCodeList?.map(el => ({ label: el?.Name, value: el?.Id }))
                setCompanyCodeList(listItems);
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const getSupplierClassificationList = () => {
        axiosHelper.get(API.getSupplierClassificationList).then((response) => {
            if (response.data.IsSuccessful) {
                let listItems = response?.data?.Data?.SupplierClassificationList?.map(el => ({ label: el?.Name, value: el?.Id }))
                setSupplierClassificationList(listItems);
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const getCurrencyMasterList = () => {
        getCurrencyList()
            .then((res) => {
                if (res?.IsSuccessful) {
                    let list = res?.Data.map(el => ({ label: el?.CurrencyName, value: el?.PCId }));
                    setCurrencyMasterList(list);
                }
            })
            .catch(() => { });
    };

    const getReconciliationAccountByAccountGroupId = (groupId) => {
        let payload = {
            AccountGroupId: groupId,
            VendorRequirementRegistrationId: vendorRequirementRegistrationId
        }
        axiosHelper.post(API.getReconciliationAccountByAccountGroupId, payload)
            .then((response) => {
                if (response?.data?.IsSuccessful) {
                    setValue("ReconciliationAccount", response?.data?.Data[0]?.ReconciliationAccountName)
                }
            })
            .catch((error) => {
                if (!error?.response?.data?.IsSuccessful) {
                    notify.error(error?.response?.data?.ErrorMessage)
                }
                // apiErrors(error);
                // throw error; // Re-throw the error to the caller
            });
    }

    const hidePageLoader = () => setTimeout(() => {
        setShowTabLoader(false);
    }, 2000);

    useEffect(() => {
        getCategoryMaster();
        getPaymentTerms();
        getCurrencyMasterList();
        getGroupingKeyList();
        getPaymentMethodList();
        getPurchasingOrganizationList();
        getAccountGroupReconciliationList();
        getCompanyCodeList()
        getSupplierClassificationList()
        getOriginOfSource()
    }, [])



    useEffect(() => {
        if (
            kys2Detail &&
            categoryList.length > 0 &&
            paymentTerms.length > 0 &&
            currencyMasterList.length > 0 &&
            groupingKeyList.length > 0 &&
            paymentMethodList.length > 0 &&
            purchasingOrganizationList.length > 0 &&
            accountGroupReconciliationList.length > 0 &&
            companyCodeList.length > 0 &&
            supplierClassificationList.length > 0 &&
            sourceOfOriginList.length > 0
        ) {
            fillKys2FormData(kys2Detail)
        }
    }, [kys2Detail, categoryList, paymentTerms, currencyMasterList, groupingKeyList, paymentMethodList, purchasingOrganizationList, accountGroupReconciliationList, companyCodeList, supplierClassificationList, sourceOfOriginList])


    const onSubmitKys2Form = (values, actionType) => {
        let payload = cloneDeep(values);

        payload.SupplierCategory = values?.SupplierCategory?.value;
        payload.PaymentTerms = values?.PaymentTerms?.value;
        payload.GroupingKey = values?.GroupingKey?.value;
        payload.CompanyCode = values?.CompanyCode?.value;
        payload.PaymentCurrency = values?.PaymentCurrency?.value;
        payload.PurchasingOrganization = values?.PurchasingOrganization?.value;
        payload.VendorGSTClassification = values?.VendorGSTClassification?.value;
        payload.AccountGroup = values?.AccountGroup?.value;
        payload.PaymentMethod = values?.PaymentMethod?.value;
        payload.Origin_of_Sources = values?.Origin_of_Sources?.value;
        payload.VendorRequirementRegistrationId = vendorRequirementRegistrationId;
        payload.CostSheetDocumentAttachment = costSheetDocumentAttachment;
        payload.CodeOfConductDocumentAttachment = codeOfConductDocumentAttachment;
        payload.ProductSourcingDocumentAttachment = productSourcingDocumentAttachment;
        setKys2FormSubmitData(payload);
        if (actionType === 'Rejected') {
            setIsRejectKys2PopupOpen(true);
        }
        //Remark from modal is not required in approve case. Remark from "Party has been introduced in Havells Group by whom" will be taken for approve case
        if (actionType === 'Approved') {
            submitKys2Request("Approved", payload)
        }
        if (actionType === 'Update') {
            setUpdateKys2PopupOpen(true);
        }
    }

    const submitKys2Request = (actionType, formData = null) => {
        let payload = actionType === 'Approved' ? formData : kys2FormSubmitData;
        payload.Action = actionType === 'Update' ? 'Approved' : actionType; // For update action 'approved' is accepted
        payload.ApproverEmployeeId = parseInt(userData?.EmployeeId);
        if (actionType === 'Rejected') {
            payload.ApproverRemark = kys2RejectRemark;
        }

        setShowTabLoader(true);
        setIsApproveKys2PopupOpen(false);
        setIsRejectKys2PopupOpen(false);
        setUpdateKys2PopupOpen(false);
        setKys2RejectRemark("")
        axiosHelper.post(API.addKYS2FormDetail, payload).then((response) => {
            if (response?.data?.IsSuccessful) {
                notify.success(response?.data?.Data?.Message);
                hidePageLoader()
                history.push('/vendor-need-list');
            }
        }).catch((error) => {
            if (error.response.status === 401) {
                apiErrors(error)
            } else {
                if (!error?.response?.data?.IsSuccessful) {
                    notify.error(error?.response?.data?.ErrorMessage);
                    hidePageLoader()
                }
            }
            // apiErrors(error);
            // throw error; // Re-throw the error to the caller
        });
    }

    const onExceptionFlowSubmit = (data) => {
        let payload = cloneDeep(data)
        payload.ResonDetail = data?.ResonDetail?.map((el, index) => {
            delete payload[`ExpectedDateOfCorrection_${el?.value}`];
            return ({
                ExceptionalFlowReasonID: el?.value,
                ExpectedDateOfCorrection: data[`ExpectedDateOfCorrection_${el?.value}`]
            })
        })
        payload.VendorRequirementRegistrationId = vendorRequirementRegistrationId;
        payload.RequestInitiatedBy = parseInt(userData?.EmployeeId);
        payload.RequestSendDate = new Date();
        payload.AuditScoreValue = 0;
        payload.NSAAuditDetailID = 0;

        setIsExceptionalFlowModalOpen(false)
        setShowTabLoader(true);
        ieReset();
        axiosHelper.post(APIUSEROLD.intiateExceptionFlow, payload).then((response) => {
            if (response?.data?.IsSuccessful) {
                notify.success(response?.data?.FriendlyMessage);
                history.push('/vendor-need-list');
                setShowTabLoader(false);
            }

        }).catch((error) => {
            if (error.response.status === 401) {
                apiErrors(error)
            } else {

                if (!error?.response?.data?.IsSuccessful) {
                    notify.error(error?.response?.data?.ErrorMessage)
                    setShowTabLoader(false);
                }
            }
        });
    };

    const handleAction = (e, action) => {
        e.preventDefault()
        handleSubmit(onSubmitKys2Form)(action); // Call handleSubmit manually
    };

    let selectedExceptionalFlowReasons = ieWatch("ResonDetail")
    return (
        <>
            {showTabLoader && (<LoaderCustom customClass="simulation-Loader" />)}
            {
                !kys2Detail?.IsKYS2FormEditable ?
                    <KysTwoView kys2Data={kys2Detail} viewDataFromSupplier={viewDataFromSupplier} />
                    :
                    <div className='mt-0 hl-kys-two-wrap'>
                        {
                            !kys2Detail?.IsKYS2FormEditing &&
                            kys2Detail?.IsKYS2FormEditable &&
                            kys2Detail?.KYS2LevelOneApprover.includes(parseInt(userData?.EmployeeId)) && (
                                kys2Detail?.IsExceptionalFlowButtonVisible && (
                                    <div className='text-right mb-2'>
                                        <button
                                            type="button"
                                            className="submit-button save-btn mr5 mt-1"
                                            onClick={() => setIsExceptionalFlowModalOpen(true)}
                                        >
                                            <div className="save-icon"></div>
                                            {"Initiate Exception Flow"}
                                        </button>
                                    </div>

                                )
                            )
                        }

                        <form>
                            <Row className="part-detail-wrapper">
                                <Col md="3">
                                    <SearchableSelectHookForm
                                        name="SupplierCategory"
                                        register={register}
                                        options={categoryList}
                                        label="Supplier Category"
                                        rules={{ required: true }}
                                        placeholder="Select"
                                        Controller={Controller}
                                        control={control}
                                        mandatory={true}
                                        errors={errors?.SupplierCategory}
                                        disabled={true}
                                        handleChange={() => { }}
                                    />
                                </Col>
                                <Col md="3">
                                    <SearchableSelectHookForm
                                        label={"Payment Terms"}
                                        name={"PaymentTerms"}
                                        placeholder={"Select"}
                                        Controller={Controller}
                                        control={control}
                                        options={paymentTerms}
                                        rules={{ required: true }}
                                        register={register}
                                        mandatory={true}
                                        handleChange={() => { }}
                                        errors={errors?.PaymentTerms}
                                        disabled={false}
                                    />
                                </Col>
                                <Col md="3">
                                    <SearchableSelectHookForm
                                        label={"Grouping Key"}
                                        name={"GroupingKey"}
                                        placeholder={"Select"}
                                        options={groupingKeyList}
                                        Controller={Controller}
                                        control={control}
                                        rules={{ required: true }}
                                        register={register}
                                        mandatory={true}
                                        handleChange={() => { }}
                                        errors={errors?.GroupingKey}
                                        disabled={false}
                                    />
                                </Col>
                                <Col md="3">
                                    {/* This will be prefilled by the data from getkys2 api. It is a mandatory field concluded after discussion with Ravi. For the time being because HavellsBusinessContribution data is not coming from api therefore making this field editable. */}
                                    <TextFieldHookForm
                                        label={`Havells Business Contribution`}
                                        name={"HavellsBusinessContribution"}
                                        Controller={Controller}
                                        control={control}
                                        placeholder={"Enter"}
                                        handleChange={() => { }}
                                        rules={{
                                            required: true,
                                            validate: { checkWhiteSpaces, number },
                                            maxLength: 20,
                                        }}
                                        customClassName={"withBorder"}
                                        errors={errors?.HavellsBusinessContribution}
                                        disabled={true}
                                        mandatory={true}
                                        appendText="%"
                                        inputWrapClass="hl-append-wrap"
                                        appendClass="d-block-input"
                                    />
                                </Col>
                                <Col md="3">
                                    <SearchableSelectHookForm
                                        label={"Company Code"}
                                        name={"CompanyCode"}
                                        placeholder={"Select"}
                                        options={companyCodeList}
                                        Controller={Controller}
                                        control={control}
                                        rules={{ required: true }}
                                        register={register}
                                        mandatory={true}
                                        handleChange={() => { }}
                                        errors={errors?.CompanyCode}
                                        disabled={false}
                                    />
                                </Col>
                                <Col md="3">
                                    <SearchableSelectHookForm
                                        label={"Order Currency"}
                                        name={"PaymentCurrency"}
                                        placeholder={"Select"}
                                        options={currencyMasterList}
                                        Controller={Controller}
                                        control={control}
                                        rules={{ required: true }}
                                        register={register}
                                        mandatory={true}
                                        handleChange={() => { }}
                                        errors={errors?.PaymentCurrency}
                                        disabled={false}
                                    />
                                </Col>
                                <Col md="3">
                                    <SearchableSelectHookForm
                                        label={"Purchasing Organization"}
                                        name={"PurchasingOrganization"}
                                        placeholder={"Select"}
                                        options={purchasingOrganizationList}
                                        Controller={Controller}
                                        control={control}
                                        rules={{ required: false }}
                                        register={register}
                                        mandatory={false}
                                        handleChange={() => { }}
                                        errors={errors?.PurchasingOrganization}
                                        disabled={false}
                                    />
                                </Col>
                                <Col md="3">
                                    <SearchableSelectHookForm
                                        label={"Supplier GST Classification"}
                                        name={"VendorGSTClassification"}
                                        placeholder={"Select"}
                                        options={supplierClassificationList}
                                        Controller={Controller}
                                        control={control}
                                        rules={{ required: true }}
                                        register={register}
                                        mandatory={true}
                                        handleChange={() => { }}
                                        errors={errors?.VendorGSTClassification}
                                        disabled={false}
                                    />
                                </Col>
                                <Col md="3">
                                    <SearchableSelectHookForm
                                        label={"Account Group"}
                                        name={"AccountGroup"}
                                        placeholder={"Select"}
                                        options={accountGroupReconciliationList}
                                        Controller={Controller}
                                        control={control}
                                        rules={{ required: true }}
                                        register={register}
                                        mandatory={true}
                                        handleChange={(option) => {
                                            if (option?.value) {
                                                getReconciliationAccountByAccountGroupId(option?.value);
                                            }
                                        }}
                                        errors={errors?.AccountGroup}
                                        disabled={false}
                                    />
                                </Col>
                                <Col md="3">
                                    <TextFieldHookForm
                                        label={`Reconciliation Account`}
                                        name={"ReconciliationAccount"}
                                        Controller={Controller}
                                        control={control}
                                        placeholder={"Enter"}
                                        handleChange={() => { }}
                                        rules={{
                                            required: false,
                                            validate: { checkWhiteSpaces },
                                            maxLength: 100,
                                        }}
                                        customClassName={"withBorder"}
                                        errors={errors?.ReconciliationAccount}
                                        disabled={true}
                                        mandatory={false}
                                    />
                                </Col>
                                <Col md="3">
                                    {/* This will be prefilled by the data from getkys2 api. It is a mandatory field concluded after discussion with Ravi. For the time being because soc data is not coming from api therefore making this field editable. */}
                                    <TextFieldHookForm
                                        label={`SOC Code`}
                                        name={"SOCCode"}
                                        Controller={Controller}
                                        control={control}
                                        placeholder={"Enter"}
                                        handleChange={() => { }}
                                        rules={{
                                            required: true,
                                            validate: { checkWhiteSpaces, number },
                                            maxLength: 20,
                                        }}
                                        customClassName={"withBorder"}
                                        errors={errors?.SOCCode}
                                        disabled={false}
                                        mandatory={true}
                                    />
                                </Col>
                                <Col md="3">
                                    <SearchableSelectHookForm
                                        label={"Payment Method"}
                                        name={"PaymentMethod"}
                                        placeholder={"Select"}
                                        options={paymentMethodList}
                                        Controller={Controller}
                                        control={control}
                                        rules={{ required: true }}
                                        register={register}
                                        mandatory={true}
                                        handleChange={() => { }}
                                        errors={errors?.PaymentMethod}
                                        disabled={false}
                                    />
                                </Col>
                                <Col md="12"><hr class="hr-seprator my-2" /></Col>
                            </Row>
                            <Row className="part-detail-wrapper mt-2">
                                <Col md="12">
                                    <Row className="mt-3">
                                        <Col md="3">
                                            <Label>
                                                Have you met the owner director of the company?
                                                <span className="asterisk-required">*</span>
                                            </Label>
                                            <Label className="d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box" check  >
                                                <input
                                                    type="radio"
                                                    {...register("IsMetOwnerOrDirector", { required: radioValidateMsg })}
                                                    className="zero-based"
                                                    value={true}
                                                // defaultChecked
                                                />
                                                <span>Yes</span>
                                            </Label>
                                            <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check >
                                                <input
                                                    type="radio"
                                                    {...register("IsMetOwnerOrDirector", { required: radioValidateMsg })}
                                                    className="zero-based"
                                                    value={false}
                                                // defaultChecked
                                                />
                                                <span>No</span>
                                            </Label>
                                            {errors?.IsMetOwnerOrDirector && (
                                                <div className="text-help">
                                                    {errors?.IsMetOwnerOrDirector?.message}
                                                </div>
                                            )}
                                            {
                                                watch("IsMetOwnerOrDirector") === "false" && (
                                                    <TextAreaHookForm
                                                        label={`Remark`}
                                                        name={"OwnerOfCompanyRemark"}
                                                        Controller={Controller}
                                                        control={control}
                                                        register={register}
                                                        placeholder={"Enter"}
                                                        handleChange={() => { }}
                                                        rules={{
                                                            required: true,
                                                            validate: { checkWhiteSpaces },
                                                            maxLength: 250,
                                                            minLength: {
                                                                value: 20,
                                                                message: "Minimum length is 20"
                                                            }
                                                        }}
                                                        customClassName={"withBorder"}
                                                        errors={errors?.OwnerOfCompanyRemark}
                                                        disabled={false}
                                                        mandatory={true}
                                                    />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="12"><hr class="hr-seprator my-2" /></Col>
                                <Col md="12">
                                    <Row className="mt-2">
                                        <Col md="3">
                                            <Row className="mt-3">
                                                <Col md="12" className='d-flex justify-content-between'>
                                                    <Label>Address proof document copy attached<span className="asterisk-required">*</span></Label>
                                                    {
                                                        !!kys2Detail?.AddressProofDocumentUrl && (
                                                            <div className='hl-upload-delete-wrap hl-upload-main mb-0'>
                                                                <div className='hl-download-btn'>
                                                                    <button
                                                                        className={`btn btn-secondary hl-download-btn hl-upload-btn ml-0 hl-mb-0`}
                                                                        onClick={(e) => triggerFileDownloadByUrl(e, kys2Detail?.AddressProofDocumentUrl)}
                                                                        title="Download"
                                                                    >
                                                                        <div className="download mr-0"></div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </Col>
                                                <Col md="12">
                                                    <Label className={"d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box"} check >
                                                        <input
                                                            type="radio"
                                                            {...register("AddressProof", { required: radioValidateMsg })}
                                                            className="zero-based"
                                                            value={true}
                                                        // defaultChecked
                                                        />
                                                        <span>Yes</span>
                                                    </Label>
                                                    <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check  >
                                                        <input
                                                            type="radio"
                                                            {...register("AddressProof", { required: radioValidateMsg })}
                                                            className="zero-based"
                                                            value={false}
                                                        // defaultChecked
                                                        />
                                                        <span>No</span>
                                                    </Label>
                                                    {errors?.AddressProof && (
                                                        <div className="text-help">
                                                            {errors?.AddressProof?.message}
                                                        </div>
                                                    )}
                                                    {
                                                        watch("AddressProof") === "false" && (
                                                            <TextAreaHookForm
                                                                label={`Remark`}
                                                                name={"AddressProofRemark"}
                                                                Controller={Controller}
                                                                control={control}
                                                                register={register}
                                                                placeholder={"Enter"}
                                                                handleChange={() => { }}
                                                                rules={{
                                                                    required: true,
                                                                    validate: { checkWhiteSpaces },
                                                                    maxLength: 250,
                                                                    minLength: {
                                                                        value: 20,
                                                                        message: "Minimum length is 20"
                                                                    }
                                                                }}
                                                                customClassName={"withBorder"}
                                                                errors={errors?.AddressProofRemark}
                                                                disabled={false}
                                                                mandatory={true}
                                                            />
                                                        )
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="12"><hr class="hr-seprator my-2" /></Col>
                                {
                                    viewDataFromSupplier?.SupplierOrigin === 1 && (
                                        <>
                                            <Col md="12">
                                                <Row className="mt-2">
                                                    <Col md="3">
                                                        <Row className="mt-3">
                                                            <Col md="12" className='d-flex justify-content-between'>
                                                                <Label>Copy of PAN card attached<span className="asterisk-required">*</span>
                                                                </Label>
                                                                {
                                                                    !!kys2Detail?.PANCardDocumentUrl && (
                                                                        <div className='hl-upload-delete-wrap hl-upload-main mb-0'>
                                                                            <div className='hl-download-btn'>
                                                                                <button
                                                                                    className={`btn btn-secondary hl-download-btn hl-upload-btn ml-0 hl-mb-0`}
                                                                                    onClick={(e) => triggerFileDownloadByUrl(e, kys2Detail?.PANCardDocumentUrl)}
                                                                                    title="Download"
                                                                                >
                                                                                    <div className="download mr-0"></div>
                                                                                </button>
                                                                                {/* <div className='hl-file-title'>
                                                                        <span>{kys2Detail?.PANCardDocumentName}</span>
                                                                    </div> */}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            </Col>
                                                            <Col md="12">
                                                                <Label className={"d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box"} check  >
                                                                    <input
                                                                        type="radio"
                                                                        {...register("PANCard", { required: radioValidateMsg })}
                                                                        className="zero-based"
                                                                        value={true}
                                                                    // defaultChecked
                                                                    />
                                                                    <span>Yes</span>
                                                                </Label>
                                                                <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check  >
                                                                    <input
                                                                        type="radio"
                                                                        {...register("PANCard", { required: radioValidateMsg })}
                                                                        className="zero-based"
                                                                        value={false}
                                                                    // defaultChecked
                                                                    />
                                                                    <span>No</span>
                                                                </Label>
                                                                {errors?.PANCard && (
                                                                    <div className="text-help">
                                                                        {errors?.PANCard?.message}
                                                                    </div>
                                                                )}
                                                                {
                                                                    watch("PANCard") === "false" && (
                                                                        <TextAreaHookForm
                                                                            label={`Remark`}
                                                                            name={"PANCardRemark"}
                                                                            Controller={Controller}
                                                                            control={control}
                                                                            register={register}
                                                                            placeholder={"Enter"}
                                                                            handleChange={() => { }}
                                                                            rules={{
                                                                                required: true,
                                                                                validate: { checkWhiteSpaces },
                                                                                maxLength: 250,
                                                                                minLength: {
                                                                                    value: 20,
                                                                                    message: "Minimum length is 20"
                                                                                }
                                                                            }}
                                                                            customClassName={"withBorder"}
                                                                            errors={errors?.PANCardRemark}
                                                                            disabled={false}
                                                                            mandatory={true}
                                                                        />
                                                                    )
                                                                }
                                                            </Col>

                                                        </Row>
                                                    </Col>
                                                    {
                                                        kys2Detail?.PanCardNumber && (
                                                            <Col md="3" className="mt-3">
                                                                <Label className='fw-bold'>{kys2Detail?.PanCardNumber}</Label>
                                                            </Col>
                                                        )
                                                    }
                                                </Row>
                                            </Col>
                                            <Col md="12"><hr class="hr-seprator my-2" /></Col>
                                            <Col md="12">
                                                <Row className="mt-2">
                                                    <Col md="3">
                                                        <Label>
                                                            MSME Supplier<span className="asterisk-required">*</span>
                                                        </Label>
                                                        <Label className={"d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box"} check    >
                                                            <input
                                                                type="radio"
                                                                {...register("IsMSMESupplier", { required: radioValidateMsg })}
                                                                className="zero-based"
                                                                value={true}
                                                            // defaultChecked
                                                            />
                                                            <span>Yes</span>
                                                        </Label>
                                                        <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check  >
                                                            <input
                                                                type="radio"
                                                                {...register("IsMSMESupplier", { required: radioValidateMsg })}
                                                                className="zero-based"
                                                                value={false}
                                                            // defaultChecked
                                                            />
                                                            <span>No</span>
                                                        </Label>
                                                        {errors?.IsMSMESupplier && (
                                                            <div className="text-help">
                                                                {errors?.IsMSMESupplier?.message}
                                                            </div>
                                                        )}
                                                        {
                                                            watch("IsMSMESupplier") === "false" && (
                                                                <TextAreaHookForm
                                                                    label={`Remark`}
                                                                    name={"MSMESupplierRemark"}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    register={register}
                                                                    placeholder={"Enter"}
                                                                    handleChange={() => { }}
                                                                    rules={{
                                                                        required: true,
                                                                        validate: { checkWhiteSpaces },
                                                                        maxLength: 250,
                                                                        minLength: {
                                                                            value: 20,
                                                                            message: "Minimum length is 20"
                                                                        }
                                                                    }}
                                                                    customClassName={"withBorder"}
                                                                    errors={errors?.MSMESupplierRemark}
                                                                    disabled={false}
                                                                    mandatory={true}
                                                                />
                                                            )
                                                        }
                                                    </Col>
                                                    {
                                                        kys2Detail?.MSMECertificateNumber && (
                                                            <Col md="3" className="mt-3">
                                                                <Label className='fw-bold'>{kys2Detail?.MSMECertificateNumber}</Label>
                                                            </Col>
                                                        )
                                                    }
                                                </Row>
                                            </Col>
                                            <Col md="12"><hr class="hr-seprator my-2" /></Col>
                                            <Col md="12">
                                                <Row className="mt-2">
                                                    <Col md="3">
                                                        <Row className="mt-3">
                                                            <Col md="10">
                                                                <Label>
                                                                    MSME certificate copy attached
                                                                    <span className="asterisk-required">*</span>
                                                                </Label>
                                                            </Col>
                                                            <Col md="2" className='d-flex justify-content-center'>
                                                                {
                                                                    !!kys2Detail?.MSMECertificateDocumentUrl && (
                                                                        <div className='hl-upload-delete-wrap hl-upload-main mb-0'>
                                                                            <div className='hl-download-btn'>
                                                                                <button
                                                                                    className={`btn btn-secondary hl-download-btn hl-upload-btn ml-0 hl-mb-0`}
                                                                                    onClick={(e) => triggerFileDownloadByUrl(e, kys2Detail?.MSMECertificateDocumentUrl)}
                                                                                    title="Download"
                                                                                >
                                                                                    <div className="download mr-0"></div>
                                                                                </button>
                                                                                {/* <div className='hl-file-title'>
                                                                <span>{kys2Detail?.MSMECertificateDocumentName}</span>
                                                            </div> */}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            </Col>
                                                            <Col md="12">
                                                                <Label className={"d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box"} check >
                                                                    <input
                                                                        type="radio"
                                                                        {...register("MSMECertificate", { required: radioValidateMsg })}
                                                                        className="zero-based"
                                                                        value={true}
                                                                    // defaultChecked
                                                                    />
                                                                    <span>Yes</span>
                                                                </Label>
                                                                <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check >
                                                                    <input
                                                                        type="radio"
                                                                        {...register("MSMECertificate", { required: radioValidateMsg })}
                                                                        className="zero-based"
                                                                        value={false}
                                                                    // defaultChecked
                                                                    />
                                                                    <span>No</span>
                                                                </Label>
                                                                {errors?.MSMECertificate && (
                                                                    <div className="text-help">
                                                                        {errors?.MSMECertificate?.message}
                                                                    </div>
                                                                )}
                                                                {
                                                                    watch("MSMECertificate") === "false" && (
                                                                        <TextAreaHookForm
                                                                            label={`Remark`}
                                                                            name={"MSMECertificateRemark"}
                                                                            Controller={Controller}
                                                                            control={control}
                                                                            register={register}
                                                                            placeholder={"Enter"}
                                                                            handleChange={() => { }}
                                                                            rules={{
                                                                                required: true,
                                                                                validate: { checkWhiteSpaces },
                                                                                maxLength: 250,
                                                                                minLength: {
                                                                                    value: 20,
                                                                                    message: "Minimum length is 20"
                                                                                }
                                                                            }}
                                                                            customClassName={"withBorder"}
                                                                            errors={errors?.MSMECertificateRemark}
                                                                            disabled={false}
                                                                            mandatory={true}
                                                                        />
                                                                    )
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md="12"><hr class="hr-seprator my-2" /></Col>
                                        </>
                                    )
                                }

                                <Col md="12">
                                    <Row className="mt-3">
                                        <Col md="3">
                                            <Row className="mt-3">
                                                <Col md="10">
                                                    <Label>
                                                        {
                                                            viewDataFromSupplier?.SupplierOrigin === 1 && (
                                                                <>
                                                                    Cancelled cheque
                                                                </>
                                                            )
                                                        }
                                                        {
                                                            viewDataFromSupplier?.SupplierOrigin === 2 && (
                                                                <>
                                                                    Duly signed & stamp letter of declaration/PI for bank detail
                                                                </>
                                                            )
                                                        }
                                                        <span className="asterisk-required">*</span>
                                                    </Label>

                                                </Col>
                                                <Col md="2" className='d-flex justify-content-center'>
                                                    {
                                                        !!kys2Detail?.CancelledChequeDocumentUrl && (
                                                            <div className='hl-upload-delete-wrap hl-upload-main mb-0'>
                                                                <div className='hl-download-btn'>
                                                                    <button
                                                                        className={`btn btn-secondary hl-download-btn hl-upload-btn ml-0 hl-mb-0`}
                                                                        onClick={(e) => triggerFileDownloadByUrl(e, kys2Detail?.CancelledChequeDocumentUrl)}
                                                                        title="Download"
                                                                    >
                                                                        <div className="download mr-0"></div>
                                                                    </button>
                                                                    {/* <div className='hl-file-title'>
                                                                        <span>{kys2Detail?.CancelledChequeDocumentName}</span>
                                                                    </div> */}
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </Col>
                                                <Col md="12">
                                                    <Label className={"d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box"} check >
                                                        <input
                                                            type="radio"
                                                            {...register("CancelledCheque", { required: radioValidateMsg })}
                                                            className="zero-based"
                                                            value={true}
                                                        // defaultChecked
                                                        />
                                                        <span>Yes</span>
                                                    </Label>
                                                    <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check>
                                                        <input
                                                            type="radio"
                                                            {...register("CancelledCheque", { required: radioValidateMsg })}
                                                            className="zero-based"
                                                            value={false}
                                                        // defaultChecked
                                                        />
                                                        <span>No</span>
                                                    </Label>
                                                    {errors?.CancelledCheque && (
                                                        <div className="text-help">
                                                            {errors?.CancelledCheque?.message}
                                                        </div>
                                                    )}
                                                    {
                                                        watch("CancelledCheque") === "false" && (
                                                            <TextAreaHookForm
                                                                label={`Remark`}
                                                                name={"CancelledChequeRemark"}
                                                                Controller={Controller}
                                                                control={control}
                                                                register={register}
                                                                placeholder={"Enter"}
                                                                handleChange={() => { }}
                                                                rules={{
                                                                    required: true,
                                                                    validate: { checkWhiteSpaces },
                                                                    maxLength: 250,
                                                                    minLength: {
                                                                        value: 20,
                                                                        message: "Minimum length is 20"
                                                                    }
                                                                }}
                                                                customClassName={"withBorder"}
                                                                errors={errors?.CancelledChequeRemark}
                                                                disabled={false}
                                                                mandatory={true}
                                                            />
                                                        )
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="12"><hr class="hr-seprator my-2" /></Col>
                                {
                                    viewDataFromSupplier?.SupplierOrigin === 1 && (
                                        <>
                                            <Col md="12">
                                                <Row className="mt-3">
                                                    <Col md="3">
                                                        <Row className="mt-3">
                                                            <Col md="12">
                                                                <Label>
                                                                    Copy of GSTIN attached, and GST compliance status checked
                                                                    <span className="asterisk-required">*</span>
                                                                </Label>
                                                            </Col>
                                                            <Col md="2" className='d-flex justify-content-center'>
                                                                {
                                                                    !!kys2Detail?.GSTINCertificateDocumentUrl && (
                                                                        <div className='hl-upload-delete-wrap hl-upload-main mb-0'>
                                                                            <div className='hl-download-btn'>
                                                                                <button
                                                                                    className={`btn btn-secondary hl-download-btn hl-upload-btn ml-0 hl-mb-0`}
                                                                                    onClick={(e) => triggerFileDownloadByUrl(e, kys2Detail?.GSTINCertificateDocumentUrl)}
                                                                                    title="Download"
                                                                                >
                                                                                    <div className="download mr-0"></div>
                                                                                </button>
                                                                                {/* <div className='hl-file-title'>
                                                                <span>{kys2Detail?.GSTINCertificateDocumentName}</span>
                                                            </div> */}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            </Col>
                                                            <Col md="12">
                                                                <Label className={"d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box"} check >
                                                                    <input
                                                                        type="radio"
                                                                        {...register("GSTINCertificate", { required: radioValidateMsg })}
                                                                        className="zero-based"
                                                                        value={true}
                                                                    // defaultChecked
                                                                    />
                                                                    <span>Yes</span>
                                                                </Label>
                                                                <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check  >
                                                                    <input
                                                                        type="radio"
                                                                        {...register("GSTINCertificate", { required: radioValidateMsg })}
                                                                        className="zero-based"
                                                                        value={false}
                                                                    // defaultChecked
                                                                    />
                                                                    <span>No</span>
                                                                </Label>
                                                                {errors?.GSTINCertificate && (
                                                                    <div className="text-help">
                                                                        {errors?.GSTINCertificate?.message}
                                                                    </div>
                                                                )}
                                                                {
                                                                    watch("GSTINCertificate") === "false" && (
                                                                        <TextAreaHookForm
                                                                            label={`Remark`}
                                                                            name={"GSTINCertificateRemark"}
                                                                            Controller={Controller}
                                                                            control={control}
                                                                            register={register}
                                                                            placeholder={"Enter"}
                                                                            handleChange={() => { }}
                                                                            rules={{
                                                                                required: true,
                                                                                validate: { checkWhiteSpaces },
                                                                                maxLength: 250,
                                                                                minLength: {
                                                                                    value: 20,
                                                                                    message: "Minimum length is 20"
                                                                                }
                                                                            }}
                                                                            customClassName={"withBorder"}
                                                                            errors={errors?.GSTINCertificateRemark}
                                                                            disabled={false}
                                                                            mandatory={true}
                                                                        />
                                                                    )
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    {
                                                        kys2Detail?.GSTINCertificateNumber && (
                                                            <Col md="3" className="mt-3">
                                                                <Label className='fw-bold'>{kys2Detail?.GSTINCertificateNumber}</Label>
                                                            </Col>
                                                        )
                                                    }
                                                </Row>
                                            </Col>
                                            <Col md="12"><hr class="hr-seprator my-2" /></Col>
                                            <Col md="12">
                                                <Row className="mt-3">
                                                    <Col md="3">
                                                        <Row className="mt-3">
                                                            <Col md="10">
                                                                <Label>
                                                                    Copy of PF/ESI registration number
                                                                    <span className="asterisk-required">*</span>
                                                                </Label>
                                                            </Col>
                                                            <Col md="2" className='d-flex justify-content-center'>
                                                                {
                                                                    !!kys2Detail?.PFRegistrationDocumentUrl && (
                                                                        <div className='hl-upload-delete-wrap hl-upload-main mb-0 mr-2'>
                                                                            <div className='hl-download-btn'>
                                                                                <button
                                                                                    className={`btn btn-secondary hl-download-btn hl-upload-btn ml-0 hl-mb-0`}
                                                                                    onClick={(e) => triggerFileDownloadByUrl(e, kys2Detail?.PFRegistrationDocumentUrl)}
                                                                                    title="Download"
                                                                                >
                                                                                    <div className="download mr-0"></div>
                                                                                </button>
                                                                                {/* <div className='hl-file-title'>
                                                                                    <span>{kys2Detail?.PF_ESIRegistrationDocumentName}</span>
                                                                                </div> */}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                                {
                                                                    !!kys2Detail?.ESIRegistrationDocumentUrl && (
                                                                        <div className='hl-upload-delete-wrap hl-upload-main mb-0 mr-2'>
                                                                            <div className='hl-download-btn'>
                                                                                <button
                                                                                    className={`btn btn-secondary hl-download-btn hl-upload-btn ml-0 hl-mb-0`}
                                                                                    onClick={(e) => triggerFileDownloadByUrl(e, kys2Detail?.ESIRegistrationDocumentUrl)}
                                                                                    title="Download"
                                                                                >
                                                                                    <div className="download mr-0"></div>
                                                                                </button>
                                                                                {/* <div className='hl-file-title'>
                                                                                    <span>{kys2Detail?.PF_ESIRegistrationDocumentName}</span>
                                                                                </div> */}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            </Col>
                                                            <Col md="12">
                                                                <Label className={"d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box"} check  >
                                                                    <input
                                                                        type="radio"
                                                                        {...register("PF_ESIRegistration", { required: radioValidateMsg })}
                                                                        className="zero-based"
                                                                        value={true}
                                                                    // defaultChecked
                                                                    />
                                                                    <span>Yes</span>
                                                                </Label>
                                                                <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check >
                                                                    <input
                                                                        type="radio"
                                                                        {...register("PF_ESIRegistration", { required: radioValidateMsg })}
                                                                        className="zero-based"
                                                                        value={false}
                                                                    // defaultChecked
                                                                    />
                                                                    <span>No</span>
                                                                </Label>
                                                                {errors?.PF_ESIRegistration && (
                                                                    <div className="text-help">
                                                                        {errors?.PF_ESIRegistration?.message}
                                                                    </div>
                                                                )}
                                                                {
                                                                    watch("PF_ESIRegistration") === "false" && (
                                                                        <TextAreaHookForm
                                                                            label={`Remark`}
                                                                            name={"PF_ESIRegistrationRemark"}
                                                                            Controller={Controller}
                                                                            control={control}
                                                                            register={register}
                                                                            placeholder={"Enter"}
                                                                            handleChange={() => { }}
                                                                            rules={{
                                                                                required: true,
                                                                                validate: { checkWhiteSpaces },
                                                                                maxLength: 250,
                                                                                minLength: {
                                                                                    value: 20,
                                                                                    message: "Minimum length is 20"
                                                                                }
                                                                            }}
                                                                            customClassName={"withBorder"}
                                                                            errors={errors?.PF_ESIRegistrationRemark}
                                                                            disabled={false}
                                                                            mandatory={true}
                                                                        />
                                                                    )
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    {
                                                        (kys2Detail?.PFRegistrationNumber || kys2Detail?.ESIRegistrationNumber) && (
                                                            <Col md="3" className="mt-3">
                                                                <Label className='fw-bold'>
                                                                    {kys2Detail?.PFRegistrationNumber ? kys2Detail?.PFRegistrationNumber : "-"}
                                                                    {kys2Detail?.ESIRegistrationNumber ? ` | ${kys2Detail?.ESIRegistrationNumber}` : "-"}
                                                                </Label>
                                                            </Col>

                                                        )
                                                    }
                                                </Row>
                                            </Col>
                                            <Col md="12"><hr class="hr-seprator my-2" /></Col>
                                        </>
                                    )
                                }


                                <Col md="12">
                                    <Row className="mt-3">
                                        <Col md="3">
                                            <Row className="mt-3 mb-2">
                                                <Col md="10">
                                                    <Label>
                                                        Cost sheet attached
                                                        <span className="asterisk-required">*</span>
                                                    </Label>
                                                </Col>
                                                <Col md="2" className='d-flex justify-content-center'>
                                                    {
                                                        !!kys2Detail?.CostSheetDocumentUrl && (
                                                            <div className='hl-upload-delete-wrap hl-upload-main mb-0'>
                                                                <div className='hl-download-btn'>
                                                                    <button
                                                                        className={`btn btn-secondary hl-download-btn hl-upload-btn ml-0 hl-mb-0`}
                                                                        onClick={(e) => triggerFileDownloadByUrl(e, kys2Detail?.CostSheetDocumentUrl)}
                                                                        title="Download"
                                                                    >
                                                                        <div className="download mr-0"></div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </Col>
                                                <Col md="12">
                                                    <Label className={"d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box"} check  >
                                                        <input
                                                            type="radio"
                                                            {...register("CostSheet", { required: radioValidateMsg })}
                                                            className="zero-based"
                                                            value={true}
                                                        // defaultChecked
                                                        />
                                                        <span>Yes</span>
                                                    </Label>
                                                    <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check >
                                                        <input
                                                            type="radio"
                                                            {...register("CostSheet", { required: radioValidateMsg })}
                                                            className="zero-based"
                                                            value={false}
                                                        // defaultChecked
                                                        />
                                                        <span>No</span>
                                                    </Label>
                                                    {errors?.CostSheet && (
                                                        <div className="text-help">
                                                            {errors?.CostSheet?.message}
                                                        </div>
                                                    )}
                                                    {
                                                        watch("CostSheet") === "false" && (
                                                            <TextAreaHookForm
                                                                label={`Remark`}
                                                                name={"CostSheetRemark"}
                                                                Controller={Controller}
                                                                control={control}
                                                                register={register}
                                                                placeholder={"Enter"}
                                                                handleChange={() => { }}
                                                                rules={{
                                                                    required: true,
                                                                    validate: { checkWhiteSpaces },
                                                                    maxLength: 250,
                                                                    minLength: {
                                                                        value: 20,
                                                                        message: "Minimum length is 20"
                                                                    }
                                                                }}
                                                                customClassName={"withBorder"}
                                                                errors={errors?.CostSheetRemark}
                                                                disabled={false}
                                                                mandatory={true}
                                                            />
                                                        )
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="12"><hr class="hr-seprator my-2" /></Col>
                                <Col md="12">
                                    <Row className="mt-3">
                                        <Col md="3">
                                            <Row className="mt-3 mb-2">
                                                <Col md="10">
                                                    <Label>
                                                        Code of Conduct
                                                        <span className="asterisk-required">*</span>
                                                    </Label>
                                                </Col>
                                                <Col md="2" className='d-flex justify-content-center'>
                                                    {
                                                        !!kys2Detail?.CodeOfConductDocumentUrl && (
                                                            <div className='hl-upload-delete-wrap hl-upload-main mb-0'>
                                                                <div className='hl-download-btn'>
                                                                    <button
                                                                        className={`btn btn-secondary hl-download-btn hl-upload-btn ml-0 hl-mb-0`}
                                                                        onClick={(e) => triggerFileDownloadByUrl(e, kys2Detail?.CodeOfConductDocumentUrl)}
                                                                        title="Download"
                                                                    >
                                                                        <div className="download mr-0"></div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </Col>
                                                <Col md="12">
                                                    <Label className={"d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box"} check >
                                                        <input
                                                            type="radio"
                                                            {...register("CodeOfConduct", { required: radioValidateMsg })}
                                                            className="zero-based"
                                                            value={true}
                                                        // defaultChecked
                                                        />
                                                        <span>Yes</span>
                                                    </Label>
                                                    <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check  >
                                                        <input
                                                            type="radio"
                                                            {...register("CodeOfConduct", { required: radioValidateMsg })}
                                                            className="zero-based"
                                                            value={false}
                                                        // defaultChecked
                                                        />
                                                        <span>No</span>
                                                    </Label>
                                                    {errors?.CodeOfConduct && (
                                                        <div className="text-help">
                                                            {errors?.CodeOfConduct?.message}
                                                        </div>
                                                    )}
                                                    {
                                                        watch("CodeOfConduct") === "false" && (
                                                            <TextAreaHookForm
                                                                label={`Remark`}
                                                                name={"CodeOfConductRemark"}
                                                                Controller={Controller}
                                                                control={control}
                                                                register={register}
                                                                placeholder={"Enter"}
                                                                handleChange={() => { }}
                                                                rules={{
                                                                    required: true,
                                                                    validate: { checkWhiteSpaces },
                                                                    maxLength: 250,
                                                                    minLength: {
                                                                        value: 20,
                                                                        message: "Minimum length is 20"
                                                                    }
                                                                }}
                                                                customClassName={"withBorder"}
                                                                errors={errors?.CodeOfConductRemark}
                                                                disabled={false}
                                                                mandatory={true}
                                                            />
                                                        )
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    kys2Detail?.IsPSARequired && (
                                        <>
                                            <Col md="12"><hr class="hr-seprator my-2" /></Col>
                                            <Col md="12">
                                                <Row className="mt-3">
                                                    <Col md="3">
                                                        <Row className="mt-3 mb-2">
                                                            <Col md="10">
                                                                <Label>
                                                                    Product sourcing agreement/Job work Agreement
                                                                    <span className="asterisk-required">*</span>
                                                                </Label>
                                                            </Col>
                                                            <Col md="2" className='d-flex justify-content-center'>
                                                                {
                                                                    !!kys2Detail?.ProductSourcingDocumentUrl && (
                                                                        <div className='hl-upload-delete-wrap hl-upload-main mb-0'>
                                                                            <div className='hl-download-btn'>
                                                                                <button
                                                                                    className={`btn btn-secondary hl-download-btn hl-upload-btn ml-0 hl-mb-0`}
                                                                                    onClick={(e) => triggerFileDownloadByUrl(e, kys2Detail?.ProductSourcingDocumentUrl)}
                                                                                    title="Download"
                                                                                >
                                                                                    <div className="download mr-0"></div>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            </Col>
                                                            <Col md="12">
                                                                <Label className={"d-inline-block align-middle w-auto pl-2 pr-5 mr-5 mb-3 pt-0 radio-box"} check >
                                                                    <input
                                                                        type="radio"
                                                                        {...register("ProductSourcing", { required: radioValidateMsg })}
                                                                        className="zero-based"
                                                                        value={true}
                                                                    // defaultChecked
                                                                    />
                                                                    <span>Yes</span>
                                                                </Label>
                                                                <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check  >
                                                                    <input
                                                                        type="radio"
                                                                        {...register("ProductSourcing", { required: radioValidateMsg })}
                                                                        className="zero-based"
                                                                        value={false}
                                                                    // defaultChecked
                                                                    />
                                                                    <span>No</span>
                                                                </Label>
                                                                {errors?.ProductSourcing && (
                                                                    <div className="text-help">
                                                                        {errors?.ProductSourcing?.message}
                                                                    </div>
                                                                )}
                                                                {
                                                                    watch("ProductSourcing") === "false" && (
                                                                        <TextAreaHookForm
                                                                            label={`Remark`}
                                                                            name={"ProductSourcingRemark"}
                                                                            Controller={Controller}
                                                                            control={control}
                                                                            register={register}
                                                                            placeholder={"Enter"}
                                                                            handleChange={() => { }}
                                                                            rules={{
                                                                                required: true,
                                                                                validate: { checkWhiteSpaces },
                                                                                maxLength: 250,
                                                                                minLength: {
                                                                                    value: 20,
                                                                                    message: "Minimum length is 20"
                                                                                }
                                                                            }}
                                                                            customClassName={"withBorder"}
                                                                            errors={errors?.ProductSourcingRemark}
                                                                            disabled={false}
                                                                            mandatory={true}
                                                                        />
                                                                    )
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </>
                                    )
                                }

                            </Row>
                            <Row className="part-detail-wrapper mt-2">
                                <Col md="12"><hr class="hr-seprator mb-4 mt-0" /></Col>
                                <Col md="12" className='d-flex'>
                                    <HeaderTitle title={"Party has been introduced in Havells Group by whom"} /></Col>
                                <Col md="3">
                                    <TextFieldHookForm
                                        label={`Name`}
                                        name={"Name"}
                                        Controller={Controller}
                                        control={control}
                                        register={register}
                                        placeholder={"Enter"}
                                        handleChange={() => { }}
                                        rules={{
                                            required: true,
                                            validate: { checkWhiteSpaces, alphabetsOnlyForName },
                                            maxLength: 100,
                                        }}
                                        customClassName={"withBorder"}
                                        errors={errors?.Name}
                                        disabled={false}
                                        mandatory={true}
                                    />
                                </Col>
                                <Col md="3">
                                    <TextFieldHookForm
                                        label={`Department Name`}
                                        name={"DepartmentName"}
                                        register={register}
                                        Controller={Controller}
                                        control={control}
                                        placeholder={"Enter"}
                                        handleChange={() => { }}
                                        rules={{
                                            required: true,
                                            validate: { checkWhiteSpaces, alphaNumeric },
                                            maxLength: 100,
                                        }}
                                        customClassName={"withBorder"}
                                        errors={errors?.DepartmentName}
                                        disabled={false}
                                        mandatory={true}
                                    />
                                </Col>
                                <Col md="3">
                                    <TextFieldHookForm
                                        label={`Contact Person Name(Supplier)`}
                                        name={"ContactPersonName"}
                                        register={register}
                                        Controller={Controller}
                                        control={control}
                                        placeholder={"Enter"}
                                        handleChange={() => { }}
                                        rules={{
                                            required: true,
                                            validate: { checkWhiteSpaces, alphabetsOnlyForName },
                                            maxLength: 100,
                                        }}
                                        customClassName={"withBorder"}
                                        errors={errors?.ContactPersonName}
                                        disabled={false}
                                        mandatory={true}
                                    />
                                </Col>
                                <Col md="3">
                                    <SearchableSelectHookForm
                                        label={"Origin of Sources"}
                                        name={"Origin_of_Sources"}
                                        placeholder={"Select"}
                                        options={sourceOfOriginList}
                                        Controller={Controller}
                                        control={control}
                                        rules={{ required: true }}
                                        register={register}
                                        mandatory={true}
                                        handleChange={() => { }}
                                        errors={errors?.Origin_of_Sources}
                                        disabled={!!watch("Origin_of_Sources")} // Disable if value is present
                                    />
                                </Col>
                                <Col md="3">
                                    <TextAreaHookForm
                                        label={"Remark"}
                                        name={"Remark"}
                                        rules={{
                                            required: true,
                                            validate: { checkWhiteSpaces },
                                            maxLength: 250,
                                            minLength: {
                                                value: 20,
                                                message: "Minimum length is 20"
                                            }
                                        }}
                                        placeholder={true ? "Enter" : "Type here..."}
                                        Controller={Controller}
                                        control={control}
                                        register={register}
                                        mandatory={true}
                                        customClassName={"withBorder"}
                                        handleChange={() => { }}
                                        errors={errors?.Remark}
                                        disabled={false}
                                        rowHeight={3}
                                    />
                                </Col>
                                {
                                    kys2Detail?.IsResponseFieldRequired && (
                                        <Col md="3">
                                            <TextAreaHookForm
                                                label={"Response Remark"}
                                                name={"ResponseRemark"}
                                                rules={{
                                                    required: true,
                                                    validate: { checkWhiteSpaces },
                                                    maxLength: 250,
                                                    minLength: {
                                                        value: 20,
                                                        message: "Minimum length is 20"
                                                    }
                                                }}
                                                placeholder={true ? "Enter" : "Type here..."}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                customClassName={"withBorder"}
                                                handleChange={() => { }}
                                                errors={errors?.ResponseRemark}
                                                disabled={false}
                                                rowHeight={3}
                                            />
                                        </Col>
                                    )
                                }
                            </Row>
                            <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer hl-btm-footer mt-3">
                                <div className="col-sm-12 text-right bluefooter-butn">
                                    {(
                                        kys2Detail?.IsKYS2FormEditable &&
                                        kys2Detail?.IsKYS2FormEditing &&
                                        kys2Detail?.KYS2LevelOneApprover.includes(parseInt(userData?.EmployeeId))
                                    ) && (
                                            <button type="submit" className="submit-button save-btn mr5" onClick={(e) => handleAction(e, 'Update')}>
                                                <div className="save-icon"></div>
                                                Approve
                                            </button>
                                        )}
                                    {
                                        (
                                            kys2Detail?.IsKYS2FormEditable &&
                                            kys2Detail?.IsKYS2FormEditing &&
                                            kys2Detail?.IsKYS2FormRejectable &&
                                            kys2Detail?.KYS2LevelOneApprover.includes(parseInt(userData?.EmployeeId))
                                        ) && (
                                            <button type="submit" name="reject" className="mr5 approve-reject-btn"
                                                onClick={(e) => handleAction(e, 'Rejected')}>
                                                <div className={"cancel-icon-white mr5"}></div>
                                                {"Reject"}
                                            </button>
                                        )
                                    }
                                    {
                                        (
                                            !kys2Detail?.IsKYS2FormEditing &&
                                            kys2Detail?.IsKYS2FormEditable &&
                                            kys2Detail?.KYS2LevelOneApprover.includes(parseInt(userData?.EmployeeId))
                                        ) && (
                                            <>
                                                {/* {kys2Detail?.IsExceptionalFlowButtonVisible && (
                                                    <button
                                                        type="button"
                                                        className="submit-button save-btn mr5"
                                                        onClick={() => setIsExceptionalFlowModalOpen(true)}
                                                    >
                                                        <div className="save-icon"></div>
                                                        {"Initiate Exception Flow"}
                                                    </button>
                                                )} */}
                                                <button type="submit" name="approve" className="approve-button mr5 approve-hover-btn"
                                                    onClick={(e) => handleAction(e, 'Approved')}
                                                >
                                                    <div className="save-icon mr-1"></div>
                                                    {"Approve"}
                                                </button>
                                                <button type="submit" name="reject" className="mr5 approve-reject-btn"
                                                    onClick={(e) => handleAction(e, 'Rejected')}>
                                                    <div className={"cancel-icon-white mr5"}></div>
                                                    {"Reject"}
                                                </button>
                                            </>
                                        )
                                    }
                                </div>
                            </Row>
                        </form>
                        <PopupMsgWrapper
                            isOpen={isExceptionalFlowModalOpen}
                            firstButtonName="Send"
                            secondButtonName="Cancel"
                            header="Exception Flow Request"
                            closePopUp={() => {
                                setIsExceptionalFlowModalOpen(false)
                                ieReset()
                                // setSelectedExceptionalFlowReasons([])
                            }}
                            confirmPopup={() => {
                                ieHandleSubmit(onExceptionFlowSubmit)();
                            }}
                            customClass="hl-invite-supplier"
                            message={
                                <>
                                    <Col md="12" className="hl-error-cmtitle">
                                        <form className="hl-re-audit-pop-up">
                                            <Row className="text-start mb-2">
                                                <Col lg="12">
                                                    <SearchableSelectHookForm
                                                        label="Reason"
                                                        name={"ResonDetail"}
                                                        placeholder={"Select"}
                                                        isMulti={true}
                                                        Controller={Controller}
                                                        control={ieControl}
                                                        rules={{ required: true }}
                                                        register={ieRegister}
                                                        options={exceptionalFlowReasons}
                                                        isClearable={false}
                                                        handleChange={(items, action) => {
                                                            if (action?.action === "remove-value") {
                                                                const fieldToReset = `ExpectedDateOfCorrection_${action?.removedValue?.value}`;
                                                                ieFormController.setValue(`${fieldToReset}`, null);
                                                            }
                                                        }}
                                                        errors={ieErrors?.ResonDetail}
                                                    />
                                                </Col>
                                                <Col lg="12" className='mt-2'>
                                                    {selectedExceptionalFlowReasons?.length > 0 && selectedExceptionalFlowReasons.find(reason => reason?.label !== "Payment Terms") && (
                                                        <label><strong>Expected date of document submission</strong></label>
                                                    )}
                                                </Col>
                                                <Col lg="12">
                                                    <Row>
                                                        {selectedExceptionalFlowReasons?.map((reason) => (
                                                            reason?.label !== "Payment Terms" && (
                                                                <Col md="12" className='mb-3' key={reason?.value}>
                                                                    <label>{reason?.label}</label>
                                                                    <Controller
                                                                        className="w-100"
                                                                        control={ieControl}
                                                                        name={`ExpectedDateOfCorrection_${reason?.value}`}
                                                                        rules={{ required: "This field is required" }}
                                                                        render={({ field }) => (
                                                                            <>
                                                                                <DatePicker
                                                                                    id={`${reason?.value}_date`}
                                                                                    placeholderText="Select Date"
                                                                                    onChange={(date) => field.onChange(date)}
                                                                                    selected={field.value}
                                                                                    showMonthDropdown
                                                                                    showYearDropdown
                                                                                    dropdownMode="select"
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    autoComplete="off"
                                                                                    disabledKeyboardNavigation
                                                                                    onChangeRaw={(e) => e.preventDefault()}
                                                                                    className={`form-control hl-datepicker-date mh-inherit withBorder ExpectedDateOfCorrection_${reason?.value}`}
                                                                                    minDate={todayDate}
                                                                                />
                                                                                {ieErrors && <span className="text-help">{ieErrors?.[`ExpectedDateOfCorrection_${reason?.value}`]?.message}</span>}
                                                                            </>
                                                                        )}
                                                                    />
                                                                </Col>
                                                            )
                                                        ))}
                                                        {
                                                            selectedExceptionalFlowReasons?.map((reason, index) => {
                                                                if (reason?.label == "Payment Terms") {
                                                                    return (
                                                                        <React.Fragment key={reason?.value}>
                                                                            {
                                                                                selectedExceptionalFlowReasons.length > 1 && (
                                                                                    <Col md="12"><hr class="hr-seprator" /></Col>
                                                                                )
                                                                            }
                                                                            <Col md="12" className='mb-3'>
                                                                                <label>{reason?.label}</label>
                                                                            </Col>
                                                                        </React.Fragment>
                                                                    )
                                                                }
                                                                return null;
                                                            })}
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <TextAreaHookForm
                                                label={`Remarks`}
                                                name={"RequestSentRemark"}
                                                Controller={Controller}
                                                control={ieControl}
                                                register={ieRegister}
                                                placeholder={"Enter"}
                                                rules={{
                                                    required: true,
                                                    validate: { checkWhiteSpaces },
                                                    maxLength: 250,
                                                    minLength: {
                                                        value: 20,
                                                        message: "Minimum length is 20"
                                                    }
                                                }}
                                                handleChange={() => { }}
                                                errors={ieErrors?.RequestSentRemark}
                                                customClassName={"withBorder"}
                                                mandatory={true}
                                            />
                                        </form>
                                    </Col>
                                </>
                            }
                        />
                        <PopupMsgWrapper
                            firstButtonName="Submit"
                            secondButtonName="Cancel"
                            header="Update KYS 2?"
                            isOpen={updateKys2PopupOpen}
                            closePopUp={() => {
                                setUpdateKys2PopupOpen(false)
                            }}
                            confirmPopup={() => submitKys2Request("Update")}
                            message={<>  </>}
                            iconClass="d-none"
                            imgClass="hl-img-confirmation"
                            popupWrapper="popup-wrapper-main"
                        />
                        {
                            isRejectKys2PopupOpen && (
                                <PopupMsgWrapper
                                    firstButtonName="Submit"
                                    secondButtonName="Cancel"
                                    header="Reject KYS 2 request?"
                                    isOpen={isRejectKys2PopupOpen}
                                    closePopUp={() => {
                                        setIsRejectKys2PopupOpen(false)
                                        setKys2RejectRemark("")
                                    }}
                                    confirmPopup={() => {
                                        if (!kys2RejectRemark) {
                                            setIsRejectKys2PopupOpen(true);
                                        } else {
                                            submitKys2Request("Rejected")
                                        }
                                    }}
                                    isInputField={true}
                                    setInputData={(data) => { setKys2RejectRemark(data) }}
                                    message={<>  </>}
                                    iconClass="d-none"
                                    imgClass="hl-img-confirmation"
                                    popupWrapper="popup-wrapper-main"
                                />
                            )
                        }
                    </div>
            }
        </>
    )
}

export default KysTwoForm;